module.exports = __webpack_public_path__ + "img/grid-4.9b97f6e5.svg";